import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'https://api.traceeye-ce-demo.sato.co.jp/api',
    formatArchiveUrl: 'https://traceeye-ce-demo.sato.co.jp/',
};
